import {AbstractControl, ValidatorFn} from '@angular/forms';

export class AutoCompleteValidators {

    static valueSelected(input: any[]): ValidatorFn {
        return (c: AbstractControl): { [key: string]: boolean } | null => {
            let selectboxValue = c.value;
            let pickedOrNot = input.filter(
                (option) => option === selectboxValue
            );

            if (pickedOrNot.length > 0) {
                // everything's fine. return no error. therefore it's null.
                return null;
            } else {
                //there's no matching selectboxvalue selected. so return match error.
                return {match: true};
            }
        };
    }
}
